import Styles from './styles.module.scss'

function ThreeDotsLoader() {
  return <div className={Styles.three_dot_loader} />
}

export default ThreeDotsLoader
